/** @public */
export function precise(A) {
  return `${toDomPrecision(A.x)},${toDomPrecision(A.y)} `
}

/** @public */
export function average(A, B) {
  return `${toDomPrecision((A.x + B.x) / 2)},${toDomPrecision((A.y + B.y) / 2)} `
}

/** @public */
export const PI = Math.PI

/** @public */
export const HALF_PI = PI / 2

/** @public */
export const PI2 = PI * 2

/** @public */
export const SIN = Math.sin

/** @public */
export const STANDARD_VIEWPORT_WITH = 1920

/** @public */
export const STANDARD_VIEWPORT_HEIGHT = 1080

/** @public */
export const SCOPE_MIN = 0.5

/** @public */
export const SCOPE_MAX = 3.0

/** @public */
export function toDomPrecision(v) {
  return Math.round(v * 1e4) / 1e4
}

// ************************************************************
// * 캔버스 제한
// => STANDARD_VIEWPORT_WIDTH/HEIGHT: 기준 캔버스 사이즈 (1920x1080)
// ************************************************************

// [ 사용자가 얼마나 이동할 수 있는지의 한계(X/Y min/max)를 계산해서,캔버스를 벗어나는 이동을 방지하기 위한 범위(Clamp)를 설정함 ]
export function calculateTranslateLimit(scope, adjustTranslate) {
  // adjustTranslate : 디바이스 크기 비율 차이에 따라 "중앙 정렬"을 위한 오프셋 보정값
  const translateDelta = getTranslateDelta(
    STANDARD_VIEWPORT_WITH / 2,
    STANDARD_VIEWPORT_HEIGHT / 2,
    scope,
    1
  )

  // 현재 줌 상태에서 유저가 이동할 수 있는 최소/최대 X, Y 값을 계산해서 뷰포트 밖으로 나가는 것 방지
  const calc = {
    TRANSLATE_X_MIN:
      adjustTranslate.x +
      translateDelta.x -
      (STANDARD_VIEWPORT_WITH * (scope - SCOPE_MIN)) / (2 * scope * SCOPE_MIN),
    TRANSLATE_Y_MIN:
      adjustTranslate.y +
      translateDelta.y -
      (STANDARD_VIEWPORT_HEIGHT * (scope - SCOPE_MIN)) / (2 * scope * SCOPE_MIN),
    TRANSLATE_X_MAX:
      adjustTranslate.x +
      translateDelta.x +
      (STANDARD_VIEWPORT_WITH * (scope - SCOPE_MIN)) / (2 * scope * SCOPE_MIN),
    TRANSLATE_Y_MAX:
      adjustTranslate.y +
      translateDelta.y +
      (STANDARD_VIEWPORT_HEIGHT * (scope - SCOPE_MIN)) / (2 * scope * SCOPE_MIN),
  }
  // console.log(scope, calc, 'calcs')
  return calc
}

// [ 스코프와 캔버스 크기에 따라 이동이 가능한 범위를 제한: 클램핑 ]
// [ 현재 scope와 디바이스 크기에 따라 실제 translate 값이 얼마인지 계산 ]
export function adjustTranslateCoordinate(translateXYCoordinate, scope, scaleRatio) {
  const sgCanvasElement = document.getElementById('sg-canvas')
  const sgCanvasElementClientRect = sgCanvasElement.getBoundingClientRect()

  let adjustTranslate = { x: 0, y: 0 }
  // case: 16:9 비율보다 가로가 긴 경우
  if (
    sgCanvasElementClientRect.width * STANDARD_VIEWPORT_HEIGHT >=
    sgCanvasElementClientRect.height * STANDARD_VIEWPORT_WITH
  ) {
    // 디바이스의 height 기준, 16:9 비율의 가로 길이 구하기
    let totalWidth =
      (STANDARD_VIEWPORT_HEIGHT * sgCanvasElementClientRect.width) /
      sgCanvasElementClientRect.height
    adjustTranslate = { x: (totalWidth - STANDARD_VIEWPORT_WITH) / (2 * SCOPE_MIN), y: 0 }
  }
  // case: 16:9 비율보다 세로가 긴 경우
  else {
    // 디바이스의 width 기준, 16:9 비율의 세로 길이 구하기
    let totalHeight =
      (STANDARD_VIEWPORT_WITH * sgCanvasElementClientRect.height) / sgCanvasElementClientRect.width
    adjustTranslate = { x: 0, y: (totalHeight - STANDARD_VIEWPORT_HEIGHT) / (2 * SCOPE_MIN) }
  }

  const { TRANSLATE_X_MIN, TRANSLATE_Y_MIN, TRANSLATE_X_MAX, TRANSLATE_Y_MAX } =
    calculateTranslateLimit(scope / scaleRatio, adjustTranslate)

  if (translateXYCoordinate.x < TRANSLATE_X_MIN) translateXYCoordinate.x = TRANSLATE_X_MIN

  if (translateXYCoordinate.x > TRANSLATE_X_MAX) translateXYCoordinate.x = TRANSLATE_X_MAX

  if (translateXYCoordinate.y < TRANSLATE_Y_MIN) translateXYCoordinate.y = TRANSLATE_Y_MIN

  if (translateXYCoordinate.y > TRANSLATE_Y_MAX) translateXYCoordinate.y = TRANSLATE_Y_MAX
  return translateXYCoordinate
}

export function test(translateXYCoordinate, scope, scaleRatio) {
  /*   // const sgCanvasElement = document.getElementById('sg-canvas')
  // if (!sgCanvasElement) return ''

  // const sgCanvasElementClientRect = sgCanvasElement.getBoundingClientRect()

  // let adjustTranslate = { x: 0, y: 0 }
  // // case: 16:9 비율보다 가로가 긴 경우
  // if (
  //   sgCanvasElementClientRect.width * STANDARD_VIEWPORT_HEIGHT >=
  //   sgCanvasElementClientRect.height * STANDARD_VIEWPORT_WITH
  // ) {
  //   // 디바이스의 height 기준, 16:9 비율의 가로 길이 구하기
  //   let totalWidth =
  //     (STANDARD_VIEWPORT_HEIGHT * sgCanvasElementClientRect.width) /
  //     sgCanvasElementClientRect.height
  //   adjustTranslate = { x: (totalWidth - STANDARD_VIEWPORT_WITH) / (2 * SCOPE_MIN), y: 0 }
  // }
  // // case: 16:9 비율보다 세로가 긴 경우
  // else {
  //   // 디바이스의 width 기준, 16:9 비율의 세로 길이 구하기
  //   let totalHeight =
  //     (STANDARD_VIEWPORT_WITH * sgCanvasElementClientRect.height) / sgCanvasElementClientRect.width
  //   adjustTranslate = { x: 0, y: (totalHeight - STANDARD_VIEWPORT_HEIGHT) / (2 * SCOPE_MIN) }
  // }

  // console.log(scope, scaleRatio, adjustTranslate)
  const { TRANSLATE_X_MIN, TRANSLATE_Y_MIN, TRANSLATE_X_MAX, TRANSLATE_Y_MAX } =
    calculateTranslateLimit(scope / scaleRatio, { x: 0, y: 0 })
  // calculateTranslateLimit(scope / scaleRatio, adjustTranslate)

  // let temp = structuredClone(translateXYCoordinate)
  let temp = { x: translateXYCoordinate.x, y: translateXYCoordinate.y }
  if (temp.x < TRANSLATE_X_MIN) temp.x = TRANSLATE_X_MIN

  if (temp.x > TRANSLATE_X_MAX) temp.x = TRANSLATE_X_MAX

  if (temp.y < TRANSLATE_Y_MIN) temp.y = TRANSLATE_Y_MIN

  if (temp.y > TRANSLATE_Y_MAX) temp.y = TRANSLATE_Y_MAX
  // console.log(TRANSLATE_X_MIN, TRANSLATE_Y_MIN, TRANSLATE_X_MAX, TRANSLATE_Y_MAX)
  return temp */
}

/* export function adjustTranslateGestureCoordinate(
  translateXYCoordinate,
  scope,
  scaleRatio,
  downCenterRef,
  currentCenter
) {
  const sgCanvasElement = document.getElementById('sg-canvas')
  const sgCanvasElementClientRect = sgCanvasElement.getBoundingClientRect()

  let adjustTranslate = { x: 0, y: 0 }
  if (
    sgCanvasElementClientRect.width * STANDARD_VIEWPORT_HEIGHT >=
    sgCanvasElementClientRect.height * STANDARD_VIEWPORT_WITH
  ) {
    // translate
    let totalWidth =
      (STANDARD_VIEWPORT_HEIGHT * sgCanvasElementClientRect.width) /
      sgCanvasElementClientRect.height
    adjustTranslate = { x: (totalWidth - STANDARD_VIEWPORT_WITH) / (2 * SCOPE_MIN), y: 0 }
  } else {
    // translate
    let totalHeight =
      (STANDARD_VIEWPORT_WITH * sgCanvasElementClientRect.height) / sgCanvasElementClientRect.width
    adjustTranslate = { x: 0, y: (totalHeight - STANDARD_VIEWPORT_HEIGHT) / (2 * SCOPE_MIN) }
  }

  const { TRANSLATE_X_MIN, TRANSLATE_Y_MIN, TRANSLATE_X_MAX, TRANSLATE_Y_MAX } =
    calculateTranslateLimit(scope / scaleRatio, adjustTranslate)

  if (translateXYCoordinate.x < TRANSLATE_X_MIN) {
    downCenterRef.current.x = currentCenter.x
    translateXYCoordinate.x = TRANSLATE_X_MIN
  }

  if (translateXYCoordinate.x > TRANSLATE_X_MAX) {
    downCenterRef.current.x = currentCenter.x
    translateXYCoordinate.x = TRANSLATE_X_MAX
  }

  if (translateXYCoordinate.y < TRANSLATE_Y_MIN) {
    downCenterRef.current.y = currentCenter.y
    translateXYCoordinate.y = TRANSLATE_Y_MIN
  }

  if (translateXYCoordinate.y > TRANSLATE_Y_MAX) {
    downCenterRef.current.y = currentCenter.y
    translateXYCoordinate.y = TRANSLATE_Y_MAX
  }
  return translateXYCoordinate
}
 */

// ************************************************************
// * 좌표, 배율 사칙연산. Coordinates
// ************************************************************

export function addCoordinates(coord1, coord2) {
  return { x: +(coord1.x + coord2.x).toFixed(2), y: +(coord1.y + coord2.y).toFixed(2) }
}

export function subtractCoordinates(coord1, coord2) {
  return { x: +(coord1.x - coord2.x).toFixed(2), y: +(coord1.y - coord2.y).toFixed(2) }
}

export function multiplyCoordinates(coord1, coord2) {
  return { x: +(coord1.x * coord2.x).toFixed(2), y: +(coord1.y * coord2.y).toFixed(2) }
}

export function divideCoordinates(coord1, coord2) {
  return { x: +(coord1.x / coord2.x).toFixed(2), y: +(coord1.y / coord2.y).toFixed(2) }
}

export function multiplyScope(coord, scale) {
  return { x: coord.x * scale, y: coord.y * scale }
}

export function divideScope(coord, scale) {
  return { x: coord.x / scale, y: coord.y / scale }
}

export function calculateDistance(coord1, coord2) {
  return +Math.sqrt(Math.pow(coord2.x - coord1.x, 2) + Math.pow(coord2.y - coord1.y, 2)).toFixed(2)
}

export function getCanvasCoord(client, translate, scale) {
  // (clientX - translateX * scale) / scale
  // (clientY - translateY * scale) / scale
  return divideScope(subtractCoordinates(client, multiplyScope(translate, scale)), scale)
}

// [ scope 값이 변할 때 중심 좌표가 어떻게 바뀌는지 계산해주는 함수 ]
// 확대/축소할 때, 보정해야 할 translate 변화량
export function getTranslateDelta(valueX, valueY, nextScope, currentScope) {
  return {
    x: +(valueX * (1 / nextScope - 1 / currentScope)).toFixed(2),
    y: +(valueY * (1 / nextScope - 1 / currentScope)).toFixed(2),
  }
}

// Coordinate Transformation
export function getCoordinateTransformed(reference_point, ratio) {
  return (0 - reference_point) * ratio + reference_point
}

// ************************************************************
// * point related function
// ************************************************************

export function getBoundaryPoints(pathType, pathData) {
  let spacing = 10
  pathData.points = []

  if (pathType === 'image' || pathType === 'square') {
    // 위쪽 변 (minY)
    for (let x = pathData.minX; x <= pathData.maxX; x += spacing) {
      pathData.points = [...pathData.points, { x: x, y: pathData.minY }]
    }

    // 아래쪽 변 (maxY)
    for (let x = pathData.minX; x <= pathData.maxX; x += spacing) {
      pathData.points = [...pathData.points, { x: x, y: pathData.maxY }]
    }

    // 왼쪽 변 (minX)
    for (let y = pathData.minY; y <= pathData.maxY; y += spacing) {
      pathData.points = [...pathData.points, { x: pathData.minX, y: y }]
    }

    // 오른쪽 변 (maxX)
    for (let y = pathData.minY; y <= pathData.maxY; y += spacing) {
      pathData.points = [...pathData.points, { x: pathData.maxX, y: y }]
    }
  }

  if (pathType === 'line') {
    let lineSlope = (pathData.maxY - pathData.minY) / (pathData.maxX - pathData.minX)

    if (lineSlope > 1.5) {
      if (pathData.minX === 0 && pathData.maxY === 0)
        for (let y = pathData.minY; y <= pathData.maxY; y += spacing) {
          pathData.points = [...pathData.points, { x: -(y / lineSlope), y: y }]
        }
      else if (pathData.maxX === 0 && pathData.minY === 0)
        for (let y = pathData.minY; y <= pathData.maxY; y += spacing) {
          pathData.points = [...pathData.points, { x: -(y / lineSlope), y: y }]
        }
      else if (pathData.minX === 0 && pathData.minY === 0)
        for (let y = pathData.minY; y <= pathData.maxY; y += spacing) {
          pathData.points = [...pathData.points, { x: y / lineSlope, y: y }]
        }
      else if (pathData.maxX === 0 && pathData.maxY === 0)
        for (let y = pathData.minY; y <= pathData.maxY; y += spacing) {
          pathData.points = [...pathData.points, { x: y / lineSlope, y: y }]
        }
    } else {
      if (pathData.minX === 0 && pathData.maxY === 0)
        for (let x = pathData.minX; x <= pathData.maxX; x += spacing) {
          pathData.points = [...pathData.points, { x: x, y: -x * lineSlope }]
        }
      else if (pathData.maxX === 0 && pathData.minY === 0)
        for (let x = pathData.minX; x <= pathData.maxX; x += spacing) {
          pathData.points = [...pathData.points, { x: x, y: -x * lineSlope }]
        }
      else if (pathData.minX === 0 && pathData.minY === 0)
        for (let x = pathData.minX; x <= pathData.maxX; x += spacing) {
          pathData.points = [...pathData.points, { x: x, y: x * lineSlope }]
        }
      else if (pathData.maxX === 0 && pathData.maxY === 0)
        for (let x = pathData.minX; x <= pathData.maxX; x += spacing) {
          pathData.points = [...pathData.points, { x: x, y: x * lineSlope }]
        }
    }
  }

  return pathData.points
}

export function getCircleBoundaryPoints(cx, cy, rx, ry, pathData) {
  let spacing = 10
  pathData.points = []

  const circumference = Math.PI * (3 * (rx + ry) - Math.sqrt((3 * rx + ry) * (rx + 3 * ry))) // 타원 근사 둘레
  const totalPoints = Math.floor(circumference / spacing) // 점의 개수
  const angleStep = (2 * Math.PI) / totalPoints // 각도 증가량

  for (let i = 0; i < totalPoints; i++) {
    const theta = i * angleStep // 각도 계산
    const x = cx + rx * Math.cos(theta) // x 좌표 계산
    const y = cy + ry * Math.sin(theta) // y 좌표 계산
    pathData.points.push({ x, y })
  }

  return pathData.points
}

export function getTriangleBoundaryPoints(pathData) {
  let spacing = 10
  pathData.points = []

  let x1, x2, x3, y1, y2, y3

  if (pathData.minX === 0 && pathData.minY === 0) {
    x1 = 0
    y1 = pathData.maxY

    x2 = pathData.maxX / 2
    y2 = 0

    x3 = pathData.maxX
    y3 = pathData.maxY
  } else if (pathData.minX === 0 && pathData.maxY === 0) {
    x1 = 0
    y1 = pathData.minY

    x2 = pathData.maxX / 2
    y2 = pathData.maxY

    x3 = pathData.maxX
    y3 = pathData.minY
  } else if (pathData.maxX === 0 && pathData.minY === 0) {
    x1 = pathData.minX
    y1 = pathData.maxY

    x2 = pathData.minX / 2
    y2 = pathData.minY

    x3 = pathData.maxX
    y3 = pathData.maxY
  } else {
    x1 = pathData.minX
    y1 = pathData.minY

    x2 = pathData.minX / 2
    y2 = pathData.maxY

    x3 = pathData.maxX
    y3 = pathData.minY
  }

  function addPointsAlongLine(xStart, yStart, xEnd, yEnd) {
    const dx = xEnd - xStart
    const dy = yEnd - yStart
    const distance = Math.sqrt(dx * dx + dy * dy)
    const steps = Math.floor(distance / spacing)
    for (let i = 0; i <= steps; i++) {
      const t = i / steps
      const x = xStart + t * dx
      const y = yStart + t * dy
      pathData.points.push({ x, y })
    }
  }

  addPointsAlongLine(x1, y1, x2, y2)
  addPointsAlongLine(x2, y2, x3, y3)
  addPointsAlongLine(x3, y3, x1, y1)

  return pathData.points
}

/* 
export function getScaledPoints(
  horizontal,
  vertical,
  path,
  tmpPath,
  dx,
  dy,
  tmpSelectionRect,
  canvasCoord
) {
  let scaledPoints

  // [ image ]
  if (path.type === 'image') {
    let ratio = 1
    let referencePointX
    let referencePointY
    let startPointShiftX
    let startPointShiftY
    let tmpSlope
    let tdx
    let tdy

    // 대각선O
    if (horizontal !== 'N' && vertical !== 'N') {
      const isRight = horizontal === 'R'
      const isTop = vertical === 'T'
      const offsetX = isRight ? 0 : tmpSelectionRect.width
      const offsetY = isTop ? tmpSelectionRect.height : 0

      referencePointX = tmpSelectionRect.left + offsetX - tmpPath.x
      referencePointY = tmpSelectionRect.top + offsetY - tmpPath.y

      const slopeNumerator =
        canvasCoord.y - (tmpSelectionRect.top + (isTop ? tmpSelectionRect.height : 0))
      const slopeDenominator =
        canvasCoord.x - (tmpSelectionRect.left + (isRight ? 0 : tmpSelectionRect.width))
      tmpSlope = Math.abs(slopeNumerator / slopeDenominator)

      tdx = isRight ? dx : -dx
      tdy = isTop ? -dy : dy

      if (tmpSlope > tmpSelectionRect.height / tmpSelectionRect.width) {
        ratio = (tmpSelectionRect.height + tdy) / tmpSelectionRect.height

        startPointShiftX = getCoordinateTransformed(referencePointX, Math.abs(ratio))
        startPointShiftY = getCoordinateTransformed(referencePointY, ratio)
        path.y = tmpPath.y + startPointShiftY

        path.h = tmpPath.h * Math.abs(ratio)
        path.w = path.h / path.aspectRatio

        path.minY = ratio >= 0 ? tmpPath.minY * ratio : tmpPath.maxY * ratio
        path.maxY = ratio >= 0 ? tmpPath.maxY * ratio : tmpPath.minY * ratio

        if (tmpSelectionRect.width + tdx >= 0) {
          path.x = tmpPath.x + startPointShiftX
          path.minX = tmpPath.minX * Math.abs(ratio)
          path.maxX = tmpPath.maxX * Math.abs(ratio)

          path.scaleX = tmpPath.scaleX
        } else {
          path.x = tmpPath.x + startPointShiftX + 2 * (referencePointX - startPointShiftX)
          path.minX = -tmpPath.maxX * Math.abs(ratio)
          path.maxX = -tmpPath.minX * Math.abs(ratio)

          path.scaleX = -tmpPath.scaleX
        }

        if (tmpSelectionRect.height + tdy >= 0) {
          path.scaleY = tmpPath.scaleY
        } else {
          path.scaleY = -tmpPath.scaleY
        }
      } else {
        ratio = (tmpSelectionRect.width + tdx) / tmpSelectionRect.width

        startPointShiftX = getCoordinateTransformed(referencePointX, ratio)
        startPointShiftY = getCoordinateTransformed(referencePointY, Math.abs(ratio))
        path.x = tmpPath.x + startPointShiftX

        path.w = tmpPath.w * Math.abs(ratio)
        path.h = path.w * path.aspectRatio

        path.minX = ratio >= 0 ? tmpPath.minX * ratio : tmpPath.maxX * ratio
        path.maxX = ratio >= 0 ? tmpPath.maxX * ratio : tmpPath.minX * ratio

        if (tmpSelectionRect.width + tdx >= 0) {
          path.scaleX = tmpPath.scaleX
        } else {
          path.scaleX = -tmpPath.scaleX
        }

        if (tmpSelectionRect.height + tdy >= 0) {
          path.y = tmpPath.y + startPointShiftY
          path.minY = tmpPath.minY * Math.abs(ratio)
          path.maxY = tmpPath.maxY * Math.abs(ratio)
          path.scaleY = tmpPath.scaleY
        } else {
          path.y = tmpPath.y + startPointShiftY + 2 * (referencePointY - startPointShiftY)
          path.minY = -tmpPath.maxY * Math.abs(ratio)
          path.maxY = -tmpPath.minY * Math.abs(ratio)
          path.scaleY = -tmpPath.scaleY
        }
      }
    }
    // 대각선X
    else {
      // 수평 방향(x축)
      if (horizontal !== 'N') {
        // Right
        if (horizontal === 'R') {
          ratio = (tmpSelectionRect.width + dx) / tmpSelectionRect.width
          referencePointX = tmpSelectionRect.left - tmpPath.x
          referencePointY = tmpSelectionRect.top + tmpSelectionRect.height / 2 - tmpPath.y
        }
        // Left
        else if (horizontal === 'L') {
          ratio = (tmpSelectionRect.width - dx) / tmpSelectionRect.width
          referencePointX = tmpSelectionRect.left + tmpSelectionRect.width - tmpPath.x
          referencePointY = tmpSelectionRect.top + tmpSelectionRect.height / 2 - tmpPath.y
        }
        path.w = tmpPath.w * Math.abs(ratio)
        path.h = path.w * path.aspectRatio

        startPointShiftX = getCoordinateTransformed(referencePointX, ratio)
        startPointShiftY = getCoordinateTransformed(referencePointY, Math.abs(ratio))
        path.x = tmpPath.x + startPointShiftX
        path.y = tmpPath.y + startPointShiftY

        path.minX = ratio >= 0 ? tmpPath.minX * ratio : tmpPath.maxX * ratio
        path.maxX = ratio >= 0 ? tmpPath.maxX * ratio : tmpPath.minX * ratio
        path.minY = tmpPath.minY * Math.abs(ratio)
        path.maxY = tmpPath.maxY * Math.abs(ratio)
        path.scaleX = ratio >= 0 ? tmpPath.scaleX : -tmpPath.scaleX
      }

      // 수직 방향(y축)
      if (vertical !== 'N') {
        // Top
        if (vertical === 'T') {
          ratio = (tmpSelectionRect.height - dy) / tmpSelectionRect.height
          referencePointY = tmpSelectionRect.top + tmpSelectionRect.height - tmpPath.y
          referencePointX = tmpSelectionRect.left + tmpSelectionRect.width / 2 - tmpPath.x
        }
        // Bottom
        else if (vertical === 'B') {
          ratio = (tmpSelectionRect.height + dy) / tmpSelectionRect.height
          referencePointY = tmpSelectionRect.top - tmpPath.y
          referencePointX = tmpSelectionRect.left + tmpSelectionRect.width / 2 - tmpPath.x
        }
        path.h = tmpPath.h * Math.abs(ratio)
        path.w = path.h / path.aspectRatio

        startPointShiftX = getCoordinateTransformed(referencePointX, Math.abs(ratio))
        startPointShiftY = getCoordinateTransformed(referencePointY, ratio)
        path.x = tmpPath.x + startPointShiftX
        path.y = tmpPath.y + startPointShiftY

        path.minY = ratio >= 0 ? tmpPath.minY * ratio : tmpPath.maxY * ratio
        path.maxY = ratio >= 0 ? tmpPath.maxY * ratio : tmpPath.minY * ratio
        path.minX = tmpPath.minX * Math.abs(ratio)
        path.maxX = tmpPath.maxX * Math.abs(ratio)
        path.scaleY = ratio >= 0 ? tmpPath.scaleY : -tmpPath.scaleY
      }
    }

    scaledPoints = getBoundaryPoints('image', path)
  } else {
    // [draw && shape]
    let ratioX = 1
    let ratioY = 1
    let referencePointX
    let referencePointY
    let startPointShiftX
    let startPointShiftY

    // [draw && shape] - 수평 방향(x축)
    if (horizontal !== 'N') {
      // Right
      if (horizontal === 'R') {
        ratioX = (tmpSelectionRect.width + dx) / tmpSelectionRect.width
        path.w = tmpPath.w * Math.abs(ratioX)
        referencePointX = tmpSelectionRect.left - tmpPath.x
      }
      // Left
      else if (horizontal === 'L') {
        ratioX = (tmpSelectionRect.width - dx) / tmpSelectionRect.width
        path.w = tmpPath.w * Math.abs(ratioX)
        referencePointX = tmpSelectionRect.left + tmpSelectionRect.width - tmpPath.x
      }

      startPointShiftX = getCoordinateTransformed(referencePointX, ratioX)
      path.x = tmpPath.x + startPointShiftX
    }

    // [draw && shape] - 수직 방향(y축)
    if (vertical !== 'N') {
      // Top
      if (vertical === 'T') {
        ratioY = (tmpSelectionRect.height - dy) / tmpSelectionRect.height
        path.h = tmpPath.h * Math.abs(ratioY)
        referencePointY = tmpSelectionRect.top + tmpSelectionRect.height - tmpPath.y
      }
      // Bottom
      else if (vertical === 'B') {
        ratioY = (tmpSelectionRect.height + dy) / tmpSelectionRect.height
        path.h = tmpPath.h * Math.abs(ratioY)
        referencePointY = tmpSelectionRect.top - tmpPath.y
      }

      startPointShiftY = getCoordinateTransformed(referencePointY, ratioY)
      path.y = tmpPath.y + startPointShiftY
    }

    path.minX = ratioX > 0 ? tmpPath.minX * ratioX : tmpPath.maxX * ratioX
    path.maxX = ratioX > 0 ? tmpPath.maxX * ratioX : tmpPath.minX * ratioX
    path.minY = ratioY > 0 ? tmpPath.minY * ratioY : tmpPath.maxY * ratioY
    path.maxY = ratioY > 0 ? tmpPath.maxY * ratioY : tmpPath.minY * ratioY

    scaledPoints = tmpPath.points.map((point) => ({
      x: horizontal === 'N' ? point.x : point.x * ratioX,
      y: vertical === 'N' ? point.y : point.y * ratioY,
      pressure: point.pressure,
    }))
  }

  return scaledPoints
} 
*/

export function getScaledPointsWithAspectRatio(
  horizontal,
  vertical,
  path,
  tmpPath,
  dx,
  dy,
  tmpSelectionRect,
  canvasCoord
) {
  let scaledPoints

  // [ image related ratio ]
  let ratio = 1
  // [ pen-pressure / pen / pen-highlight / shape ]
  let ratioPathX = 1
  let ratioPathY = 1
  // [ common variable ]
  let referencePointX
  let referencePointY
  let startPointShiftX
  let startPointShiftY
  let tmpSlope
  let tdx
  let tdy

  const isRight = horizontal === 'R'
  const isTop = vertical === 'T'
  const offsetX = isRight ? 0 : tmpSelectionRect.width
  const offsetY = isTop ? tmpSelectionRect.height : 0

  referencePointX = tmpSelectionRect.left + offsetX - tmpPath.x
  referencePointY = tmpSelectionRect.top + offsetY - tmpPath.y

  const slopeNumerator =
    canvasCoord.y - (tmpSelectionRect.top + (isTop ? tmpSelectionRect.height : 0))
  const slopeDenominator =
    canvasCoord.x - (tmpSelectionRect.left + (isRight ? 0 : tmpSelectionRect.width))
  tmpSlope = Math.abs(slopeNumerator / slopeDenominator)

  tdx = isRight ? dx : -dx
  tdy = isTop ? -dy : dy

  if (tmpSlope > tmpSelectionRect.height / tmpSelectionRect.width) {
    ratio = (tmpSelectionRect.height + tdy) / tmpSelectionRect.height

    startPointShiftX = getCoordinateTransformed(referencePointX, Math.abs(ratio))
    startPointShiftY = getCoordinateTransformed(referencePointY, ratio)
    path.y = tmpPath.y + startPointShiftY

    path.h = tmpPath.h * Math.abs(ratio)
    path.w = path.h / path.aspectRatio

    path.minY = ratio >= 0 ? tmpPath.minY * ratio : tmpPath.maxY * ratio
    path.maxY = ratio >= 0 ? tmpPath.maxY * ratio : tmpPath.minY * ratio

    if (tmpSelectionRect.width + tdx >= 0) {
      path.x = tmpPath.x + startPointShiftX
      path.minX = tmpPath.minX * Math.abs(ratio)
      path.maxX = tmpPath.maxX * Math.abs(ratio)

      path.type === 'image' ? (path.scaleX = tmpPath.scaleX) : (ratioPathX = Math.abs(ratio))
    } else {
      path.x = tmpPath.x + startPointShiftX + 2 * (referencePointX - startPointShiftX)
      path.minX = -tmpPath.maxX * Math.abs(ratio)
      path.maxX = -tmpPath.minX * Math.abs(ratio)

      path.type === 'image' ? (path.scaleX = -tmpPath.scaleX) : (ratioPathX = -Math.abs(ratio))
    }

    if (tmpSelectionRect.height + tdy >= 0) {
      path.type === 'image' ? (path.scaleY = tmpPath.scaleY) : (ratioPathY = Math.abs(ratio))
    } else {
      path.type === 'image' ? (path.scaleY = -tmpPath.scaleY) : (ratioPathY = -Math.abs(ratio))
    }
  } else {
    ratio = (tmpSelectionRect.width + tdx) / tmpSelectionRect.width

    startPointShiftX = getCoordinateTransformed(referencePointX, ratio)
    startPointShiftY = getCoordinateTransformed(referencePointY, Math.abs(ratio))
    path.x = tmpPath.x + startPointShiftX

    path.w = tmpPath.w * Math.abs(ratio)
    path.h = path.w * path.aspectRatio

    path.minX = ratio >= 0 ? tmpPath.minX * ratio : tmpPath.maxX * ratio
    path.maxX = ratio >= 0 ? tmpPath.maxX * ratio : tmpPath.minX * ratio

    if (tmpSelectionRect.height + tdy >= 0) {
      path.y = tmpPath.y + startPointShiftY
      path.minY = tmpPath.minY * Math.abs(ratio)
      path.maxY = tmpPath.maxY * Math.abs(ratio)

      path.type === 'image' ? (path.scaleY = tmpPath.scaleY) : (ratioPathY = Math.abs(ratio))
    } else {
      path.y = tmpPath.y + startPointShiftY + 2 * (referencePointY - startPointShiftY)
      path.minY = -tmpPath.maxY * Math.abs(ratio)
      path.maxY = -tmpPath.minY * Math.abs(ratio)

      path.type === 'image' ? (path.scaleY = -tmpPath.scaleY) : (ratioPathY = -Math.abs(ratio))
    }

    if (tmpSelectionRect.width + tdx >= 0) {
      path.type === 'image' ? (path.scaleX = tmpPath.scaleX) : (ratioPathX = Math.abs(ratio))
    } else {
      path.type === 'image' ? (path.scaleX = -tmpPath.scaleX) : (ratioPathX = -Math.abs(ratio))
    }
  }

  if (path.type === 'image') {
    path.aspectRatio = path.h / path.w
    scaledPoints = getBoundaryPoints('image', path)
  } else {
    scaledPoints = tmpPath.points.map((point) => ({
      x: horizontal === 'N' ? point.x : point.x * ratioPathX,
      y: vertical === 'N' ? point.y : point.y * ratioPathY,
      pressure: point.pressure,
    }))
  }
  return scaledPoints
}

export function getScaledPointsWithoutAspectRatio(
  horizontal,
  vertical,
  path,
  tmpPath,
  dx,
  dy,
  tmpSelectionRect,
  canvasCoord
) {
  let scaledPoints

  let ratioX = 1
  let ratioY = 1
  let referencePointX
  let referencePointY
  let startPointShiftX
  let startPointShiftY

  // [draw && shape] - 수평 방향(x축)
  if (horizontal !== 'N') {
    // Right
    if (horizontal === 'R') {
      ratioX = (tmpSelectionRect.width + dx) / tmpSelectionRect.width
      path.w = tmpPath.w * Math.abs(ratioX)
      referencePointX = tmpSelectionRect.left - tmpPath.x

      if (path.type === 'image') {
        ratioX >= 0 ? (path.scaleX = tmpPath.scaleX) : (path.scaleX = -tmpPath.scaleX)
      }
    }
    // Left
    else if (horizontal === 'L') {
      ratioX = (tmpSelectionRect.width - dx) / tmpSelectionRect.width
      path.w = tmpPath.w * Math.abs(ratioX)
      referencePointX = tmpSelectionRect.left + tmpSelectionRect.width - tmpPath.x

      if (path.type === 'image') {
        ratioX >= 0 ? (path.scaleX = tmpPath.scaleX) : (path.scaleX = -tmpPath.scaleX)
      }
    }

    startPointShiftX = getCoordinateTransformed(referencePointX, ratioX)
    path.x = tmpPath.x + startPointShiftX
  }

  // [draw && shape] - 수직 방향(y축)
  if (vertical !== 'N') {
    // Top
    if (vertical === 'T') {
      ratioY = (tmpSelectionRect.height - dy) / tmpSelectionRect.height
      path.h = tmpPath.h * Math.abs(ratioY)
      referencePointY = tmpSelectionRect.top + tmpSelectionRect.height - tmpPath.y

      if (path.type === 'image') {
        ratioY >= 0 ? (path.scaleY = tmpPath.scaleY) : (path.scaleY = -tmpPath.scaleY)
      }
    }
    // Bottom
    else if (vertical === 'B') {
      ratioY = (tmpSelectionRect.height + dy) / tmpSelectionRect.height
      path.h = tmpPath.h * Math.abs(ratioY)
      referencePointY = tmpSelectionRect.top - tmpPath.y

      if (path.type === 'image') {
        ratioY >= 0 ? (path.scaleY = tmpPath.scaleY) : (path.scaleY = -tmpPath.scaleY)
      }
    }

    startPointShiftY = getCoordinateTransformed(referencePointY, ratioY)
    path.y = tmpPath.y + startPointShiftY
  }

  path.minX = ratioX > 0 ? tmpPath.minX * ratioX : tmpPath.maxX * ratioX
  path.maxX = ratioX > 0 ? tmpPath.maxX * ratioX : tmpPath.minX * ratioX
  path.minY = ratioY > 0 ? tmpPath.minY * ratioY : tmpPath.maxY * ratioY
  path.maxY = ratioY > 0 ? tmpPath.maxY * ratioY : tmpPath.minY * ratioY

  if (path.type === 'image') {
    path.aspectRatio = path.h / path.w
    scaledPoints = getBoundaryPoints('image', path)
  } else {
    scaledPoints = tmpPath.points.map((point) => ({
      x: horizontal === 'N' ? point.x : point.x * ratioX,
      y: vertical === 'N' ? point.y : point.y * ratioY,
      pressure: point.pressure,
    }))
  }

  return scaledPoints
}

// ************************************************************
// * linear interpolation function
// ************************************************************

// export function interpolatePoints(x0, y0, x1, y1, thicknessVal) {
export function interpolatePoints(x0, y0, x1, y1, thicknessVal) {
  let steps = 50
  // if (thicknessVal >= 8) steps = 10
  // if (thicknessVal < 8) steps = 100
  const points = []
  const dx = (x1 - x0) / steps
  const dy = (y1 - y0) / steps

  for (let i = 0; i <= steps; i++) {
    points.push({ x: x0 + dx * i, y: y0 + dy * i })
  }

  return points
}

// ************************************************************
// * path related function
// ************************************************************

export function getPathInitialData(
  type,
  zIndex,
  x,
  y,
  minX,
  minY,
  maxX,
  maxY,
  thicknessVal,
  opacityVal,
  strokeVal,
  strokeWidthVal,
  colorVal,
  pressure,
  isLocked,
  aspectRatio
) {
  return {
    type: type,
    zIndex: zIndex,
    // starting position of the path
    x: x,
    y: y,
    // max, min (dx, dy)
    minX: minX,
    minY: minY,
    maxX: maxX,
    maxY: maxY,
    // width and height of the path
    w: thicknessVal,
    h: thicknessVal,
    // other information of the path
    thickness: thicknessVal,
    opacity: opacityVal,
    stroke: strokeVal,
    strokeWidth: strokeWidthVal,
    fill: colorVal,
    d: `M 0 0
    m ${thicknessVal / 4}, 0
    a ${thicknessVal / 4},${thicknessVal / 4} 0 1,0 ${-thicknessVal / 2},0
    a ${thicknessVal / 4},${thicknessVal / 4} 0 1,0 ${thicknessVal / 2},0`,
    points: [{ x: 0, y: 0, pressure: pressure }],
    isLocked: isLocked,
    aspectRatio: aspectRatio,
  }
}

export function getImageInitialData(
  type,
  zIndex,
  x,
  y,
  minX,
  minY,
  maxX,
  maxY,
  w,
  h,
  opacity,
  src,
  scaleX,
  scaleY,
  aspectRatio,
  isLocked
) {
  return {
    type: type,
    zIndex: zIndex,
    // starting position of the image
    x: x,
    y: y,
    // max, min (dx, dy)
    minX: minX,
    minY: minY,
    maxX: maxX,
    maxY: maxY,
    // width and height of the image
    w: w,
    h: h,
    opacity: opacity,
    // other information of the image
    src: src,
    scaleX: scaleX,
    scaleY: scaleY,
    aspectRatio: aspectRatio,
    isLocked: isLocked,
    points: [{ x: 0, y: 0 }],
  }
}

export function handleErase(
  pathData,
  pathKey,
  pathElement,
  pointObj,
  erasedPathKeys,
  sgShapeDivElement
) {
  // draw (isPointInFill)
  if (pathData.type === 'draw') {
    if (!erasedPathKeys.current.includes(pathKey) && pathElement.isPointInFill(pointObj)) {
      erasedPathKeys.current.push(pathKey)
      sgShapeDivElement.style.opacity *= 0.25
    }
  }
  // square / circle (fill check: isPointInStroke / isPointInFill)
  else if (
    pathData.type === 'square' ||
    pathData.type === 'circle' ||
    pathData.type === 'triangle'
  ) {
    if (!erasedPathKeys.current.includes(pathKey)) {
      const isPointInsideShape =
        pathData.fill === 'none'
          ? pathElement.isPointInStroke(pointObj)
          : pathElement.isPointInFill(pointObj)

      if (isPointInsideShape) {
        erasedPathKeys.current.push(pathKey)
        sgShapeDivElement.style.opacity *= 0.25
      }
    }
  }
  // line (isPointInStroke)
  else if (pathData.type === 'line') {
    if (!erasedPathKeys.current.includes(pathKey) && pathElement.isPointInStroke(pointObj)) {
      erasedPathKeys.current.push(pathKey)
      sgShapeDivElement.style.opacity *= 0.25
    }
  }
  // error exception
  else {
    alert('Eraser Exception')
  }
}

export function getStrokeRegeneration(
  getStroke,
  thicknessVal,
  isSimulatePressure,
  isCapTrue,
  key,
  paths,
  points
) {
  let pathData

  if (paths[key].type === 'draw') {
    const stroke = getStroke(points, getStrokeOptions(thicknessVal, isSimulatePressure, isCapTrue))

    pathData = getSvgPathFromStroke(stroke)
  } else if (paths[key].type === 'image' || paths[key].type === 'square') {
    let deltaX, deltaY
    paths[key].minX === 0 ? (deltaX = paths[key].maxX) : (deltaX = paths[key].minX)
    paths[key].minY === 0 ? (deltaY = paths[key].maxY) : (deltaY = paths[key].minY)

    pathData = `M 0 0 L ${deltaX} 0 L ${deltaX} ${deltaY} L 0 ${deltaY} Z`
  } else if (paths[key].type === 'circle') {
    let cx = paths[key].minX === 0 ? paths[key].maxX / 2 : paths[key].minX / 2
    let cy = paths[key].minY === 0 ? paths[key].maxY / 2 : paths[key].minY / 2
    let rx = Math.abs(paths[key].maxX - paths[key].minX) / 2
    let ry = Math.abs(paths[key].maxY - paths[key].minY) / 2

    pathData = `M ${cx - rx}, ${cy}
    a ${rx},${ry} 0 1,0 ${2 * rx},0
    a ${rx},${ry} 0 1,0 ${-2 * rx},0 
    `
  } else if (paths[key].type === 'triangle') {
    let deltaX, deltaY
    paths[key].minX === 0 ? (deltaX = paths[key].maxX) : (deltaX = paths[key].minX)
    paths[key].minY === 0 ? (deltaY = paths[key].maxY) : (deltaY = paths[key].minY)

    pathData = `M 0 ${deltaY} L ${deltaX / 2} 0 L ${deltaX} ${deltaY} Z`
  } else if (paths[key].type === 'line') {
    let deltaX, deltaY
    paths[key].minX === 0 ? (deltaX = paths[key].maxX) : (deltaX = paths[key].minX)
    paths[key].minY === 0 ? (deltaY = paths[key].maxY) : (deltaY = paths[key].minY)

    pathData = `M 0 0 L ${deltaX} ${deltaY} Z`
  }

  return pathData
}

// perfect-freehand getStroke() options
export function getStrokeOptions(thicknessVal, isSimulatePressure, isCapTrue) {
  return {
    size: thicknessVal,
    thinning: 0.5,
    smoothing: 0.5,
    streamline: 0.05, // 보정값 0.05
    easing: (t) => t,
    simulatePressure: isSimulatePressure,
    start: {
      taper: 0,
      easing: (t) => t,
      cap: isCapTrue,
    },
    end: {
      taper: isSimulatePressure ? 20 : 0,
      easing: (t) => t,
      cap: isCapTrue,
    },
  }
}

export function getSvgPathFromStroke(stroke) {
  if (!stroke.length) return ''

  const d = stroke.reduce(
    (acc, [x0, y0], i, arr) => {
      const [x1, y1] = arr[(i + 1) % arr.length]
      acc.push(x0, y0, (x0 + x1) / 2, (y0 + y1) / 2)
      return acc
    },
    ['M', ...stroke[0], 'Q']
  )

  d.push('Z')
  return d.join(' ')
}
